import { render, staticRenderFns } from "./CadastroCampanhas.vue?vue&type=template&id=132099ed&"
import script from "./CadastroCampanhas.vue?vue&type=script&lang=js&"
export * from "./CadastroCampanhas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports